import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/content/article_list',
	DETAIL: '/content/article_detail',
	ADD: '/content/article_add',
	UPDATE: '/content/article_update',
	DELETE: '/content/article_del'
};

export function articleList(params) {
	return requestGet(api.LIST, params);
}

export function articleDetail(id) {
	return requestGet(api.DETAIL, { id });
}

export function articleAdd(form) {
	return requestPost(api.ADD, form);
}

export function articleUpdate(form) {
	return requestPost(api.UPDATE, form);
}

export function articleDelete(id) {
	return requestPost(api.DELETE, { id });
}
